import { createAction, props } from '@ngrx/store';
import { CloudNormalCompare } from '../../../../core/models/cloud-normal/cloud-normal-compare-model';

export const loadCloudNormalCompares = createAction('[Cloud Normal Facade] Load Cloud Compares');

export const loadCloudNormalComparesSuccess = createAction(
    '[Cloud Normal Effects] Load Cloud Compares Success',
    props<{ cloudNormalCompare: Array<CloudNormalCompare> }>()
);
